import React, { type FC } from 'react';
import type { IConversationRun } from '../model/ConversationRun';
import { FeedbackType } from '../model/Feedback';
import classNames from 'classnames';
import styles from './assistantResponse.module.scss';
import { FeedbackContent } from './FeedbackContent';

export const RunFeedback: FC<{ run: IConversationRun; hidden: boolean }> = ({ run, hidden }) => {
    const [openedFeedback, setOpenedFeedback] = React.useState<FeedbackType | undefined>(undefined);

    const containerClass = classNames(styles.feedback, {
        [styles.hidden]: hidden && !openedFeedback,
    });

    return (
        <div className={containerClass}>
            <FeedbackContent
                run={run}
                feedbackType={FeedbackType.Negative}
                openedFeedback={openedFeedback}
                setOpenedFeedback={setOpenedFeedback}
            />
            <FeedbackContent
                run={run}
                feedbackType={FeedbackType.Positive}
                openedFeedback={openedFeedback}
                setOpenedFeedback={setOpenedFeedback}

            />
        </div>
    );
};
